import React from 'react';

const DataTypeIcon = ({ label, className, title }) => {
  return (
    <div className={`datatype-icon ${className || ''} ${label?.toLowerCase?.()}`} data-title={title}>
      {label?.[0]?.toUpperCase?.()}
    </div>
  );
};

export default DataTypeIcon;
